// import {
//   cibSkype,
//   cibFacebook,
//   cibTwitter,
//   cibLinkedin,
//   cibFlickr,
//   cibTumblr,
//   cibXing,
//   cibGithub,
//   cibStackOverflow,
//   cibYoutube,
//   cibDribbble,
//   cibInstagram,
//   cibPinterest,
//   cibVk,
//   cibYahoo,
//   cibBehance,
//   cibReddit,
//   cibVimeo,
//   cibCcMastercard,
//   cibCcVisa,
//   cibStripe,
//   cibPaypal,
//   cibGooglePay,
//   cibCcAmex,
//   cilBrowser,
// } from '@coreui/icons'
// import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from '@coreui/icons'
// import {
//   cilAlignCenter,
//   cilAlignLeft,
//   cilAlignRight,
//   cilApplicationsSettings,
//   cilArrowRight,
//   cilBan,
//   cilBasket,
//   cilBell,
//   cilBold,
//   cilBookmark,
//   cilCalculator,
//   cilCalendar,
//   cilCloudDownload,
//   cilChartPie,
//   cilCheck,
//   cilChevronBottom,
//   cilChevronLeft,
//   cilChevronRight,
//   cilChevronTop,
//   cilCircle,
//   cilCheckCircle,
//   cilCode,
//   cilCommentSquare,
//   cilCreditCard,
//   cilCursor,
//   cilCursorMove,
//   cilDrop,
//   cilDollar,
//   cilEnvelopeClosed,
//   cilEnvelopeLetter,
//   cilEnvelopeOpen,
//   cilEuro,
//   cilGlobeAlt,
//   cilGrid,
//   cilFile,
//   cilFullscreen,
//   cilFullscreenExit,
//   cilHome,
//   cilInbox,
//   cilIndentDecrease,
//   cilIndentIncrease,
//   cilInputPower,
//   cilItalic,
//   cilJustifyCenter,
//   cilJustifyLeft,
//   cilLaptop,
//   cilLayers,
//   cilLightbulb,
//   cilList,
//   cilListNumbered,
//   cilListRich,
//   cilLocationPin,
//   cilLockLocked,
//   cilMagnifyingGlass,
//   cilMap,
//   cilMoon,
//   cilNotes,
//   cilOptions,
//   cilPaperclip,
//   cilPaperPlane,
//   cilPencil,
//   cilPeople,
//   cilPhone,
//   cilPrint,
//   cilPuzzle,
//   cilSave,
//   cilSettings,
//   cilShare,
//   cilShareAll,
//   cilShareBoxed,
//   cilShieldAlt,
//   cilSpeech,
//   cilSpeedometer,
//   cilSpreadsheet,
//   cilStar,
//   cilSun,
//   cilTags,
//   cilTask,
//   cilTrash,
//   cilUnderline,
//   cilUser,
//   cilUserFemale,
//   cilUserFollow,
//   cilUserUnfollow,
//   cilXCircle,
//   cilWarning,
//   cilBriefcase,
//   cilBuilding,
// } from '@coreui/icons'

import * as iconsCoreUI from '@coreui/icons'

import { arrow } from './arrow'
import { logo } from './logo'
import { email } from './email'
import { emailNew } from './emailNew'
import { emailSent } from './emailSent'
import { sms } from './sms'
import { voice } from './voice'
import { userFull } from './userFull'
import { key } from './key'
import { emailFull } from './emailFull'
import { smsFull } from './smsFull'
//TODO mudar tudo para snack case ??
import { pushNotification } from './pushNotification'
import { push_notification } from './push_notification'
import { manage } from './manage'
import { note } from './note'
import { trash } from './trash'
import { arrowCircle } from './arrowCircle'
import { arrowExport } from './arrowExport'
import { checkCircle } from './checkCircle'
import { column } from './column'
import { fileFull } from './fileFull'
import { infoCircle } from './infoCircle'
import { infoSquareFull } from './infoSquareFull'
import { editFull } from './editFull'
import { peopleFull } from './peopleFull'
import { upload } from './upload'
import { approved } from './approved'
import { approvedFull } from './approvedFull'
import { pending } from './pending'
import { refused } from './refused'
import { refusedFull } from './refusedFull'
import { orderBy } from './orderBy'
import { addUser } from './addUser'
import { padlock } from './padlock'
import { segments } from './segments'
import { allAudience } from './allAudience'
import { sendNow } from './sendNow'
import { schedule } from './schedule'
import { time } from './time'
import { newSms } from './newSms'
import { smsTemplate } from './smsTemplate'
import { contentTemplate } from './contentTemplate'
import { numberSMS } from './numberSMS'
import { rocketRun } from './rocketRun'
import { rocketSend } from './rocketSend'
import { rocketSetup } from './rocketSetup'
import { clock } from './clock'
import { changeEmail } from './changeEmail'
import { insights } from './insights'
import { userBgFull } from './userBgFull'
import { simpleRocket } from './simpleRocket'
import { wallet } from './wallet'
import { copy } from './copy'
import { check } from './check'
import { walletBalance } from './walletBalance'
import { saveDisk } from './saveDisk'
import { backArrow } from './backArrow'
import { notificationAlert } from './notificationAlert'
import { twitter } from './twitter'
import { facebook } from './facebook'
import { envelopeOpen } from './envelopeOpen'
import { signOut } from './signOut'
import { cursor } from './cursor'
import { menuBurguer } from './menuBurguer'
import { users } from './users'
import { cross } from './cross'
import { plus } from './plus'
import { minus } from './minus'
import { checkMark } from './checkMark'
import { linhaBusiness } from './linhaBusiness'
import { question } from './question'
import { creditCard } from './creditCard'
import { user } from './user'
import { building } from './building'
import { dollar } from './dollar'
import { paperRight } from './paperRight'
import { chartLine } from './chartLine'
import { visa } from './visa'
import { Amex } from './amex'
import { mastercard } from './masterCard'
import { UnionPay } from './unionPay'
import { Elo } from './elo'
import { invoices } from './invoices'
import { book } from './book'
import { recover } from './recover'
import { calendar } from './calendar'
import { cookie } from './cookie'
import { cart } from './cart'
import { arrowUpGraph } from './arrowUpGraph'
import { arrowDownGraph } from './arrowDownGraph'
import { chatCircle } from './chatCircle'
import { chatCircleDots } from './chatCircleDots'
import { warningCircle } from './warningCircle'
import { circle } from './circle'
import { infoSolid } from './infoSolid'

let iconsCoreUIProcessed = (icons) => {
  let result = {}

  for (var i in icons) {
    if (Array.isArray(icons[i])) {
      result[i] = icons[i]
    } else {
      result = { ...result, ...iconsCoreUIProcessed(icons[i]) }
    }
  }
  return result
}

export const iconsSet = Object.assign(
  { ...iconsCoreUIProcessed(iconsCoreUI) },
  // {
  //   cilAlignCenter,
  //   cilAlignLeft,
  //   cilAlignRight,
  //   cilApplicationsSettings,
  //   cilArrowRight,
  //   cilBan,
  //   cilBasket,
  //   cilBell,
  //   cilBold,
  //   cilBookmark,
  //   cilBrowser,
  //   cilCalculator,
  //   cilCalendar,
  //   cilCloudDownload,
  //   cilChartPie,
  //   cilCheck,
  //   cilChevronBottom,
  //   cilChevronLeft,
  //   cilChevronRight,
  //   cilChevronTop,
  //   cilCircle,
  //   cilCheckCircle,
  //   cilCode,
  //   cilCommentSquare,
  //   cilCreditCard,
  //   cilCursor,
  //   cilCursorMove,
  //   cilDrop,
  //   cilDollar,
  //   cilEnvelopeClosed,
  //   cilEnvelopeLetter,
  //   cilEnvelopeOpen,
  //   cilEuro,
  //   cilGlobeAlt,
  //   cilGrid,
  //   cilFile,
  //   cilFullscreen,
  //   cilFullscreenExit,
  //   cilHome,
  //   cilInbox,
  //   cilIndentDecrease,
  //   cilIndentIncrease,
  //   cilInputPower,
  //   cilItalic,
  //   cilJustifyCenter,
  //   cilJustifyLeft,
  //   cilLaptop,
  //   cilLayers,
  //   cilLightbulb,
  //   cilList,
  //   cilListNumbered,
  //   cilListRich,
  //   cilLocationPin,
  //   cilLockLocked,
  //   cilMagnifyingGlass,
  //   cilMap,
  //   cilMoon,
  //   cilNotes,
  //   cilOptions,
  //   cilPaperclip,
  //   cilPaperPlane,
  //   cilPencil,
  //   cilPeople,
  //   cilPhone,
  //   cilPrint,
  //   cilPuzzle,
  //   cilSave,
  //   cilSettings,
  //   cilShare,
  //   cilShareAll,
  //   cilShareBoxed,
  //   cilShieldAlt,
  //   cilSpeech,
  //   cilSpeedometer,
  //   cilSpreadsheet,
  //   cilStar,
  //   cilSun,
  //   cilTags,
  //   cilTask,
  //   cilTrash,
  //   cilUnderline,
  //   cilUser,
  //   cilUserFemale,
  //   cilUserFollow,
  //   cilUserUnfollow,
  //   cilXCircle,
  //   cilWarning,
  //   cilBriefcase,
  //   cilBuilding,
  // },
  // {
  //   cifUs,
  //   cifBr,
  //   cifIn,
  //   cifFr,
  //   cifEs,
  //   cifPl,
  // },
  // {
  //   cibSkype,
  //   cibFacebook,
  //   cibTwitter,
  //   cibLinkedin,
  //   cibFlickr,
  //   cibTumblr,
  //   cibXing,
  //   cibGithub,
  //   cibStackOverflow,
  //   cibYoutube,
  //   cibDribbble,
  //   cibInstagram,
  //   cibPinterest,
  //   cibVk,
  //   cibYahoo,
  //   cibBehance,
  //   cibReddit,
  //   cibVimeo,
  //   cibCcMastercard,
  //   cibCcVisa,
  //   cibStripe,
  //   cibPaypal,
  //   cibGooglePay,
  //   cibCcAmex,
  // },
  {
    arrowCircle,
    arrowExport,
    checkCircle,
    column,
    infoCircle,
    infoSquareFull,
    fileFull,
    editFull,
    logo,
    email,
    emailSent,
    sms,
    voice,
    userFull,
    arrow,
    key,
    emailFull,
    smsFull,
    pushNotification,
    push_notification,
    manage,
    note,
    trash,
    peopleFull,
    upload,
    approved,
    approvedFull,
    pending,
    refused,
    refusedFull,
    orderBy,
    addUser,
    padlock,
    segments,
    allAudience,
    sendNow,
    schedule,
    time,
    newSms,
    smsTemplate,
    contentTemplate,
    numberSMS,
    rocketRun,
    rocketSend,
    rocketSetup,
    clock,
    changeEmail,
    insights,
    userBgFull,
    simpleRocket,
    wallet,
    copy,
    check,
    walletBalance,
    saveDisk,
    backArrow,
    notificationAlert,
    twitter,
    facebook,
    menuBurguer,
    users,
    emailNew,
    linhaBusiness,
    cross,
    plus,
    minus,
    checkMark,
    question,
    creditCard,
    user,
    building,
    dollar,
    paperRight,
    chartLine,
    visa,
    Amex,
    mastercard,
    UnionPay,
    Elo,
    invoices,
    book,
    recover,
    calendar,
    cookie,
    cart,
    arrowUpGraph,
    arrowDownGraph,
    chatCircle,
    chatCircleDots,
    warningCircle,
    envelopeOpen,
    signOut,
    cursor,
    circle,
    infoSolid
  },
)
